// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"nVbP-75csUIkyGN59806W"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";const Sentry = require('@sentry/nextjs');
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENV = process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV;
if (/prod/gi.test(SENTRY_ENV)) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.0075,
    sampleRate: 0.01,
    environment: SENTRY_ENV,
    defaultIntegrations: false,
    // for Deeply Nested objects are being serialised
    normalizeDepth: 11,
    ignoreErrors: [
      // The "parent.getAttribute is not a function" error occurs within the utag script on the global error page and cannot be modified, hence it is being ignored.
      'parent.getAttribute is not a function',

      // GTM related log it comes from the GTM script
      'ttq is not defined',
      `Can't find variable: ttq`,
      // There are nothing campaignCheck in our codebase
      'campaignCheck is not defined',
      // This is third-party scripts related error
      'Failed to fetch (measurement-api.criteo.com)',

      // This error occurs in the IMask library when the mask is not defined
      // Generic pattern to catch similar IMask errors
      /TypeError.*(_blocks|IMask)/,

      //Insider
      `Cannot read properties of undefined (reading 'hpm')`,
      // This error occurs in react-scroll library when spyCallbacks is undefined
      "Cannot read properties of undefined (reading 'spyCallbacks')",
      'Failed to fetch (psb.taboola.com)',
      'Failed to fetch (api.useinsider.com)',
      // The "Event `Event` (type=error) captured as promise rejection" error occurs during navigation
      'Event `Event` (type=error) captured as promise rejection',

      // It is happening with slow network Android devices.
      // If it happens frequently, we should fetch the service client-side for services with long response times.
      'Error: Connection closed',
    ],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
}
